import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ProvinceStateView } from "./ProvinceStateView";
import { ProvinceStateViewStore } from "../../store/ProvinceStateViewStore";
import { useStore } from "../../../../hooks";

export const ProvinceStateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/provinceState/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ProvinceStateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ProvinceStateView provinceStateViewStore={store} />
      </PageLayout>
    </div>
  );
});
